loader = function(fn) {
    $('#loader').fadeIn('');
    setTimeout(function() {
        fn();
    }, 3000);
}
